<template>
  <b-row>
    <b-col>
      <b-card>
        <h5>
          <strong>Centro de costos</strong>
        </h5>
        <ValidationObserver ref="observer">
          <b-form @submit.prevent="saveCostCenter" ref="formCreateCostCenter">
            <b-row class="pt-4">
              <b-col lg="4">
                <validation-provider name="nombre" :rules="{ required: true }" v-slot="validationContext">
                  <b-form-group id="input-group-company2" label="Nombre:" label-for="input-company2"
                    :invalid-feedback="validationContext.errors[0]">
                    <b-form-input id="input-company2" v-model="form.name" autocomplete="shut-up-google"
                      :state="getValidationState(validationContext)"
                      placeholder="Ingrese el nombre del centro de costo"></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="4" class="mt-3">
                <b-button variant="primary" type="submit" class="mr-2 mb-3 mt-3">Guardar</b-button>
              </b-col>
            </b-row>
            <a-divider />
          </b-form>
          <b-row>
            <b-col>
              <h5 class="mb-4">
                <strong>Lista de centros de costo</strong>
              </h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table id="table-costcenters" striped hover :fields="columns" head-variant="light" :items="centerList"
                :per-page="pagination.perPage" :current-page="pagination.currentPage" v-if="centerList.length > 0"
                responsive>
                <template #cell(actions)="element">
                  <span>
                    <button type="button" v-on:click="openModalEditCostCenter(element.item)" class="btn btn-light mr-2"
                      data-toggle="tooltip" data-placement="top" title="Editar">
                      <i class="fa fa-pencil text-blue" />
                    </button>
                    <button type="button" v-on:click="openModalRelatePUC(element.item)" class="btn btn-light mr-2"
                      data-toggle="tooltip" data-placement="top" title="Relacionar conceptos">
                      <i class="fa fa-plus text-green" />
                    </button>
                    <button type="button" v-on:click="deleteCostCenter(element.item)" class="btn btn-light mr-2"
                      data-toggle="tooltip" data-placement="top" title="Eliminar">
                      <i class="fa fa-trash text-red" />
                    </button>
                  </span>
                </template>
              </b-table>
              <empty-table v-else />
              <b-row>
                <b-col>
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.rows"
                    :per-page="pagination.perPage" aria-controls="table-costcenters"></b-pagination>
                </b-col>
                <b-col>
                  <b-button v-on:click="$emit('set-config', 0)" class="btn btn-light pull-right" variant="light">
                    Ir atrás
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </ValidationObserver>
      </b-card>
      <b-modal id="edit-costCenter" ref="modal" title="Editar centro de costo" hide-footer>
        <b-form @submit="editCostCenter" ref="editCostCenter">
          <b-form-group label="Nombre:" label-for="name">
            <b-form-input v-model="costCenterToEdit.name" placeholder="Ingrese el nombre del centro de costo"></b-form-input>
          </b-form-group>
          <b-button @click="$bvModal.hide('edit-costCenter')" variant="secondary" size="sm"
            class="mr-2 mb-3 mt-3">Cancelar</b-button>
          <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
        </b-form>
      </b-modal>
      <b-modal id="relate-PUC" ref="modal" title="Relacionar conceptos" hide-footer size="lg">
        <b-row v-show="!isSwapingElective">
          <b-col>
            <empty-table v-show="pucRelated.length === 0"/>
            <b-table v-show="pucRelated.length > 0" striped hover :fields="columnsTeacher" :items="pucRelated" head-variant="light" fixed responsive>
              <template #cell(name)="data">
                {{ data.item.name }} <br> <span class="text-secondary font-size-12">{{data.item.area}}</span>
              </template>
              <template #cell(actions)="data">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Remover electiva</span>
                  </template>
                  <button type="button" v-on:click="removeElective(data.item)" class="btn btn-light mr-2">
                    <i class="fa fa-trash" />
                  </button>
                </a-tooltip>
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Cambiar electiva</span>
                  </template>
                  <button type="button" v-on:click="showSwapElective(data.item)" class="btn btn-light mr-2">
                    <i class="fa fa-refresh" />
                  </button>
                </a-tooltip>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-2">
          <b-button type="submit" variant="primary" @click="console.log('clicked')" class="mr-2 mb-3 mt-3">Guardar</b-button>
        </b-row>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import apiClient2 from '@/services/axios/v2.js'
import emptyTable from '@/components/custom/cardEmptyList'
import { mapState } from 'vuex'
import Swal from 'sweetalert2'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  name: 'costCenter',
  components: {
    emptyTable,
  },
  data() {
    return {
      invalid: false,
      colorAsterisco: '#4b7cf3',
      form: {
        name: '',
      },
      centerList: [],
      columns: [
        { key: 'id', label: 'Código' },
        { key: 'name', label: 'Nombre' },
        { key: 'actions', label: 'Acciones' },
      ],
      pucRelated: [],
      pagination: {
        rows: 0,
        perPage: 10,
        currentPage: 1,
      },
      costCenterToEdit: {
        name: '',
        id: '',
      },
    }
  },
  computed: {
    ...mapState(['user']),
  },
  created() {
    this.getCostCenters()
      .then(() => {})
      .catch((error) => {
        console.error('Ha ocurrido un error:', error)
      })
  },
  methods: {
    getCostCenters() {
      return new Promise((resolve, reject) => {
        apiClient2.get('/cost-centers')
          .then((response) => {
            const { data } = response.data
            this.centerList = Array.isArray(data) ? data : []
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    async saveCostCenter() {
      const isValid = await this.$refs.observer.validate()
      // Si no es válido el formulario no pasa
      if (isValid) {
        apiClient2.post('/cost-centers', this.form).then(response => {
          // Reset form
          this.resetForm()
          Toast.fire({
            icon: 'success',
            title: response.data.message,
          })
          this.getCostCenters()
        })
      } else {
        Toast.fire({
          icon: 'error',
          title: 'Error al crear el centro de costo, comunicate con soporte técnico',
        })
      }
    },
    async resetForm() {
      this.form.name = ''
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
    },
    openModalEditCostCenter(costCenter) {
      const cloneCostCenter = { ...costCenter }
      this.costCenterToEdit.name = cloneCostCenter.name
      this.costCenterToEdit.id = cloneCostCenter.id
      this.$bvModal.show('edit-costCenter')
    },
    openModalRelatePUC(costCenter) {
      this.$bvModal.show('relate-PUC')
    },
    editCostCenter(evt) {
      evt.preventDefault()
      apiClient2.patch(`/cost-centers/${this.costCenterToEdit.id}`, {
        name: this.costCenterToEdit.name,
      }).then((response) => {
        this.costCenterToEdit = {}
        this.$bvModal.hide('edit-costCenter')
        Toast.fire({
          icon: 'success',
          title: response.data.message,
        })
        this.getCostCenters()
      })
    },
    deleteCostCenter(costCenter) {
      this.getDataByIdCostCenter(costCenter.id).then((data) => {
        const message = `<p style="margin:0">Se encontraron <b>${data.id}</b> empleados registrados con este centro de costo</p>`
        Swal.fire({
          title: 'Confirmar eliminación',
          html: `
              <div>
                <p style="margin:0">¿Estás seguro de eliminar el centro de costo <b>${costCenter.name}</b>?</p>
                ${data ? message : ''}
              </div>
          `,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, eliminar',
          cancelButtonText: 'No',
        }).then(async (result) => {
          if (result.isConfirmed) {
            Toast.fire({
              icon: 'success',
              title: `Centro de costos ${costCenter.name} eliminado correctamente`,
            })
          }
        })
      }).catch(e => { console.log(e) })
    },
    getDataByIdCostCenter(idCostCenter) {
      return new Promise((resolve, reject) => {
        apiClient2.get(`/cost-centers/${idCostCenter}`)
          .then((response) => {
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
  watch: {
    centerList: function (value) {
      this.pagination.rows = value.length
    },
  },
}
</script>
